import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function Cookies() {
  return <PolicyPage document={policyDocuments.cookies} />;
}

export default Cookies;
